module.exports = __webpack_public_path__ + "static_wap/img/logo.c03e759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo.png
// module id = Vpqn
// module chunks = 1